
<app-str-spinner [message]="spinnerMessage"></app-str-spinner>

<div  class="tds-row tds-u-mb2">  
    <div class="tds-col-xxlg-3 tds-col-xlg-4 tds-col-lg-4 tds-col-md-6 tds-col-sm-6 tds-col-xs-12">
        <tds-dropdown 
            name="dropdown" 
            label="Group" ngDefaultControl
            label-position="outside" 
            placeholder="Select group" 
            size="sm" 
            class="tds-u-mb1"
            open-direction="auto"> 
            <tds-dropdown-option  *ngFor="let group of reportGroupList" 
                (click)="setSelectedGroup(group)" 
                value="{{group?.groupId?.toString() || ''}}">
                {{group.groupName}}
            </tds-dropdown-option> 
        </tds-dropdown>
    </div>

    <div class="tds-col-xxlg-3 tds-col-xlg-4 tds-col-lg-4 tds-col-md-6 tds-col-sm-6 tds-col-xs-12 tds-u-pb12 tds-u-pt3">
        <tds-button [disabled]="!selectedGroup || groupListIdEmpty()"
            type="button" 
            variant="primary" 
            size="sm" 
            text="Delete group" 
            (click)="showDeleteDialog()"> 
            <tds-icon slot="icon" size="20px" name="trash"></tds-icon> 
        </tds-button>     
        <tds-button 
            type="button" 
            variant="primary" 
            size="sm" 
            class="tds-u-ml1"
            text="Add group" (click)="showAddDialog()"> 
            <tds-icon slot="icon" size="20px" name="plus"></tds-icon> 
        </tds-button>     
    </div>
</div>
<div  class="tds-row  tds-u-mb2">  
    <div class="tds-col-xxlg-3 tds-col-xlg-4 tds-col-lg-4 tds-col-md-6 tds-col-sm-6 tds-col-xs-12" *ngIf="isGroupSelected()">
        <span *ngIf="employeeList.length === 0" >Loading...</span>
        <tds-dropdown *ngIf="employeeList.length > 0"
            filter 
            label="Employee" ngDefaultControl
            label-position="outside" 
            placeholder="Select employee" 
            size="sm" 
            open-direction="auto"> 
            <tds-dropdown-option (click)="selectEmployee(employee)" 
                *ngFor="let employee of employeeList"
                value="{{employee?.email?.toString() || ''}}">
                {{employee.empName}} - {{employee.email}}
            </tds-dropdown-option> 
        </tds-dropdown>
    </div>
    <div class="tds-col-xxlg-3 tds-col-xlg-4 tds-col-lg-4 tds-col-md-6 tds-col-sm-6 tds-col-xs-12 tds-u-pb12 tds-u-pt3"*ngIf="employeeList.length > 0">
        <tds-button
            type="button" 
            variant="primary" 
            size="sm" 
            [disabled]="selectedEmployee === ''" 
            text="Add person" 
            (click)="addToGroupList()"> 
            <tds-icon slot="icon" size="20px" name="profile"></tds-icon> 
        </tds-button>     
    </div> 
</div>


<div  class="tds-row">  
    <div class="tds-col-xxlg-3 tds-col-xlg-4 tds-col-lg-4 tds-col-md-6 tds-col-sm-6 tds-col-xs-12 tds-u-mb1" *ngIf="!groupListIdEmpty()">
        <tds-table vertical-dividers="false" 
            compact-design="true" 
            responsive="true" 
            no-min-width >
            <tds-table-header >
                <tds-header-cell cell-value="Member"></tds-header-cell>
                <tds-header-cell cell-value="Remove"></tds-header-cell>
            </tds-table-header>

            <tds-table-body >
                <tds-table-body-row *ngFor="let member of selectedGroup?.member">
                    <tds-body-cell>
                        <div class="tds-u-pt2 " style="text-align: left;">
                            {{member.name}}  <span style="font-style:italic;font-size: 0.8em;">({{member.email}})</span>
                        </div>
                    </tds-body-cell>

                    <tds-body-cell style="width: 80px;">
                        <div style="text-align: left">
                            <tds-button
                                type="button" 
                                variant="danger" 
                                size="sm" 
                                text="" 
                                (click)="removeMember(member)"> 
                            <tds-icon slot="icon" size="20px" name="trash"></tds-icon> 
                        </tds-button>    
                        </div>
                    </tds-body-cell>

                </tds-table-body-row>
            </tds-table-body >
        </tds-table>
    </div>
</div>

<div *ngIf="showDeleteGroupModal">
    <tds-modal
        header="Delete group {{selectedGroup.groupName}}"
        show="true" 
        id="delete-group-modal"
        size="sm"
        actions-position="static"
        prevent="false" > 
        <span slot="body">
            <p>Are you sure you want to delete "{{selectedGroup.groupName}}" from the group list?</p>      
        </span>
        <span slot="actions"> 
            <tds-button data-dismiss-modal fullbleed style="width: 100px;" size="sm" text="Delete" variant="danger" type="primary" (click)="deleteGroup()" class="tds-u-mr1"></tds-button> 
            <tds-button data-dismiss-modal fullbleed style="width: 100px;" size="sm" type="button" variant="secondary" text="Cancel" (click)="showDeleteGroupModal=false;"></tds-button> 
        </span> 
    </tds-modal> 
</div>


<div *ngIf="showAddGroupModal">
    <tds-modal
        header="Add group"
        show="true" 
        id="add-group-modal"
        size="sm"
        actions-position="static"
        prevent="false" > 
        <span slot="body">
            <tds-text-field 
                type="Text" 
                size="sm" 
                noMinWidth
                state="default"
                label="Group name" 
                ngDefaultControl
                label-position="outside" 
                placeholder="Enter new group name" 
                [(ngModel)]="newgrouptext" > 
            </tds-text-field>{{newgrouptext}}
        </span>
        <span slot="actions"> 
            <tds-button [disabled]="newgrouptext.trim().length == 0" data-dismiss-modal fullbleed style="width: 100px;" size="sm" text="Save" type="primary" (click)="addGroup()" class="tds-u-mr1"></tds-button> 
            <tds-button data-dismiss-modal fullbleed style="width: 100px;" size="sm" type="button" variant="secondary" text="Cancel" (click)="showAddGroupModal=false;"></tds-button> 
        </span> 
    </tds-modal> 
</div>